/**
 * Created by Ning Jiang on 3/21/2017.
 */

import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {Timeline, TimelineLite} from "gsap";
import {BasicStateReelSymbol} from "../../symbols/BasicStateReelSymbol";
import {ITractorBeamBetLineInitialData} from "../TractorBeamInitialWinPresentationController";


export class TractorBeamBetLineIndividualWPController extends BetLineWinIndividualWPController {


    protected getLineAnimation(betLineWinData:ITractorBeamBetLineInitialData):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        let betLinesPerWinDirection:number = betLineWinData.lineStart === "Right" ? 4 : 0;
        let loopLength:number = betLineWinData.betLineIndex >= 0 ? betLineWinData.nrOfSymbols : (betLineWinData.betLine.length);
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, betLineWinData.betLineIndex));
        });

        for(let i:number = 0; i < loopLength; i++) {
            let reelIndex = Math.abs(betLinesPerWinDirection - i);
            if(betLineWinData.betLine[reelIndex] >= 0) {
                const symbol = Reels.getSymbol(reelIndex, betLineWinData.betLine[reelIndex]);

                if(symbol) {
                    this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, this._config.symbolTimeOffsetCalculator(timeline.totalDuration(), reelIndex, betLineWinData.betLine[reelIndex]), symbol, reelIndex, betLineWinData.betLine[reelIndex]);
                    this._winSymbols.push(symbol);
                }
            }
        }

        return timeline;
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData:IBetLineWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        const tsymbol:BasicStateReelSymbol = <BasicStateReelSymbol>symbol;

        timeline.add([
            () => this.sortSymbolDepthToTop(symbol),
            () => tsymbol.getWinAnimation()
        ], startTime);
        timeline.add(() => {}, startTime + 0.5)
    }
}
